import React from "react";
import TfBreadcrumbs from "../Common/TfBreadcrumbs";

const StatsSummary = ({ breadcrumb, stats }) => {
    return (
        <div className="tf_top_breadcrumb_rate_wrap">
            {breadcrumb && <TfBreadcrumbs breadcrumb={breadcrumb} />}
            {stats.length > 0 && (<div className="tf_box_wrap d-flex">
                {stats.map((item, index) => (
                    <div className="sh_box flex-grow-1" key={index}>
                        <p className="box_title">{item.title}</p>
                        <div className="sh_inquiry_rate">
                            {item.value}
                            {item.rate !== '' && (
                                <span className={`${item.rateType === 'down' ? 'red_text' : 'green_text'}`}>
                                    {item.percentage}%
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>)}
        </div>
    );
}

export default StatsSummary;
